import React, {Fragment, useEffect, useState} from 'react';
import {Loading} from "../index";
import {Box, TextareaAutosize, Tooltip} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import moment from "moment-jalaali";
import ReactPaginate from "react-paginate";
import {Link, useLocation} from "react-router-dom";
import queryString from "query-string";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {useParams} from "react-router";
import "../../pages/comments/comment.css"
import IconButton from "@mui/material/IconButton";
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';

const Comment = () => {

    const initStat = {}

    const [loading, setLoading] = useState(false);
    const [commentsList, setCommentsList] = useState([]);
    const param = useParams()
    const location = useLocation();
    const query = queryString.parse(location.search);
    const [page, setPage] = useState(parseInt(query.page) || 1);
    const [open, setOpen] = useState(false);
    const [noteModal, setNoteModal] = useState(false);
    const [answer, setAnswer] = useState("");
    const [note, setNote] = useState("");
    const [id, setId] = useState(null);


    useEffect(() => {
        handleList()
    }, [])

    const handleList = () => {
        setLoading(true)
        let obj = {
            "form": "product_comment_get_admin",
            "product_id": param.id,
            "status": null,
            "user_id": 2
        }
        new Api().get(`/products/comments/list/${param.id}`, obj).then((response) => {
            if (typeof response !== "undefined") {
                setCommentsList(response?.details);
            }

            setLoading(false);
        })
    }


    const handleSubmit = (id) => {
        setLoading(true)
        let obj = {
            "form": "product_comment_reply_admin",
            "text": answer
        }
        new Api().post(`/products/comments/reply/${id}`, obj, false).then((response) => {
            if (typeof response !== "undefined" && response.status) {
                setCommentsList(response);
                toast.success(response.msg)
            } else {
                toast.error(response.msg)
            }
            setOpen(false)
            setLoading(false);
        })
    }

    const handleClickOpen = (id, note = false) => {
        setId(id)
        if (note) {
            setNoteModal(true);

        } else {
            setOpen(true);
        }
    };

    const handleClose = (note = false) => {
        if (note) {
            setNoteModal(false);
        } else {
            setOpen(false);
        }
    };


    const handleComment = (item, index, isChild = false, parent = false) => {
        const haveChild = item?.children?.length > 0
        return (
            <>
                <Dialog
                    open={open && (+id === +item.id)}
                    onClose={() => handleClose(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                >
                    <form className='animate__animated animate__fadeIn' encType="multipart/form-data">
                        <DialogTitle id="alert-dialog-title">پاسخ به نظر کاربران </DialogTitle>
                        <DialogContent>
                            <TextareaAutosize
                                style={{maxWidth: "96%"}}
                                variant={"outlined"}
                                onChange={(event) => setAnswer(event.target.value)}
                                name={'answer'}
                                value={answer}/>
                            {loading && <Loading/>}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleClose(false)} color="primary">
                                بستن
                            </Button>
                            <Button disabled={loading} onClick={() => handleSubmit(item.id)} type={'submit'}
                                    color="primary" autoFocus>
                                ارسال اطلاعات
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
                <Dialog
                    open={noteModal && id === item.id}
                    onClose={() => handleClose(true)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth={true}
                >
                    <form className='animate__animated animate__fadeIn' encType="multipart/form-data">
                        <DialogTitle id="alert-dialog-title">توضیحات </DialogTitle>
                        <DialogContent>
                            <TextareaAutosize
                                style={{maxWidth: "96%"}}
                                variant={"outlined"}
                                onChange={(event) => setNote(event.target.value)}
                                name={'note'}
                                value={note}/>
                            {loading && <Loading/>}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleClose(true)} color="primary">
                                بستن
                            </Button>
                            <Button disabled={loading} onClick={() => handleAcceptOrRejection(1, item.id)}
                                    type={'submit'} color="primary" autoFocus>
                                تایید و ارسال
                            </Button>
                            <Button disabled={loading} onClick={() => handleAcceptOrRejection(2, item.id)}
                                    type={'submit'} color="primary" autoFocus>
                                رد و ارسال
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
                <div className={`${isChild ? "isChild" : "isParent"} commentsBox`}>
                    <div>
                        <span>
                            {"نام :"}
                            <Link to={'/users'}>
                                {item.user_details?.name + " " + item.user_details?.family + " /  "}
                            </Link>

                        </span>
                        <span>{"وضعیت : " + handleStatus(+item.status) + " /  "}</span>
                        <span>{"تاریخ : " + moment(item?.created_at).locale('fa').format('jYYYY/jMM/jDD - HH:mm') + " /  "}</span>
                        <span>{"امتیاز : " + +item.score}</span>

                        <div style={{
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            position: "absolute",
                            left: "5px",
                            top: "-10px"
                        }}>
                            <div style={{display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                                <Tooltip title="پاسخ">
                                    <IconButton style={{padding: "5px"}} onClick={() => handleClickOpen(item.id)}>
                                        <QuestionAnswerOutlinedIcon fontSize="small" is_label={true}/>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip onClick={() => handleClickOpen(item.id, true)} title="یادداشت">
                                    <IconButton style={{padding: "5px"}}>
                                        <NoteAddOutlinedIcon fontSize="small" is_label={true}/>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip onClick={() => handleAcceptOrRejection(2, item.id)} title="رد">
                                    <IconButton style={{padding: "5px"}}>
                                        <CloseOutlinedIcon fontSize="small" is_label={true}/>
                                    </IconButton>
                                </Tooltip>
                                <Tooltip onClick={() => handleAcceptOrRejection(1, item.id)} title="تایید">
                                    <IconButton style={{padding: "5px"}}>
                                        <DoneOutlinedIcon fontSize="small" is_label={true}/>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>

                    </div>
                    <span className={"commentText"}>{item.text}</span>
                    {
                        item.note &&
                        <span style={{color: "red", fontWeight: "bolder"}}
                              className={"commentText"}>{" یادداشت : " + item.note}</span>
                    }

                    <span>
                        {
                            haveChild && item.children?.map((item, childIndex) => {
                                return (
                                    handleComment(item, childIndex, true)
                                )
                            })
                        }
                    </span>
                </div>

            </>
        )
    };

    const handleStatus = (status) => {
        switch (status) {
            case 1:
                return "تایید شده"
            case 2:
                return "رد شده"
            default:
                return "در انتظار"

        }
    };

    const handleAcceptOrRejection = (status, commentId) => {
        setLoading(true)
        let obj = {
            "form": "product_comment_status_admin",
            "comment_id": commentId,
            "status": status,
            "note": note || null
        }
        new Api().post(`/products/comments/status`, obj, false).then((response) => {
            if (typeof response !== "undefined" && response.status) {
                toast.success(response.msg)
                handleList()
            } else {
                toast.error(response.msg)
            }
            setOpen(false)
            setNoteModal(false)
            setLoading(false)
        })
    };

    const pageCount = Math.ceil(parseInt(commentsList.total) / parseInt(commentsList?.per_page));

    return (
        <div>
            <Box>
                <>
                    <div style={{overflowX: 'auto'}}>
                        <Box>
                            <>
                                {
                                    commentsList?.map((item, index) => {

                                        return (
                                            <>
                                                {
                                                    handleComment(item, index, false, true)
                                                }
                                            </>

                                        )
                                    })
                                }
                            </>
                        </Box>
                    </div>
                    <ReactPaginate
                        previousLabel={'<'}
                        nextLabel={'>'}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                    />
                </>
                {loading && <Loading/>}
            </Box>
        </div>
    );
};

export default Comment;
